import { path } from 'ramda'

// TODO: generate arrays of this events automatically from files
const analyticEventCategories = {
  agendaSessions: [
    'changeStatusToPublished',
    'createSession',
    'editSession',
    'removeSession',
    'getSessionsList'
  ],
  agendaSettings: [
    'editSettings'
  ],
  attendee: [
    'fetchAllAttendee',
    'fetchAllAttendeeStatusesCount',
    'fetchRegularAttendeeStatusesCount',
    'fetchVipAttendeeStatusesCount',
    'resendConfirmationEmail',
    'rejectAttendee',
    'setActivitiesRegular',
    'setActivitiesVip',
    'unsetActivitiesRegular',
    'unsetActivitiesVip',
    'setStatus',
    'setInfo',
    'setMessageLimitRegulars',
    'setMessageLimitVips',
    'setIndustry',
    'setTypeRegulars',
    'setTypeVips',
    'killerFeatureTagSearchHide',
    'hideEnvelope',
    'downloadAttendeeExcel',
    'downloadAttendeesExcelAll',
    'downloadCryptoTradersExcel',
    'fetchRegularInvitations',
    'changePackageOfAttendee',
    'assignPackageToPendingPackageAttendee',
    'fetchCryptoTradersList',
    'fetchCryptoTraderPackages',
    'updateCryptoTrader',
    'updateCryptoTraderPackage',
    'assignCryptoTraderPackage',
    'updateAttendeeSubscription',
    'fetchCryptotraderInvitationLink'
  ],
  vipAttendee: [
    'getVipAttendeeList',
    'editVipAttendee',
    'fetchVipAttendeeStatusesCount',
    'changePackageOfVipAttendee'
  ],
  vipAttendeeSettings: [
    'getVipAttendeeTypes',
    'addVipAttendeeTypes',
    'editVipAttendeeTypes',
    'deleteVipAttendeeTypes'
  ],
  vipAttendeeType: [
    'fetchVIPAttendeeTypes'
  ],
  vipInvitations: [
    'sendVIPSingleLetter',
    'sendVIPMultipleLetters'
  ],
  attendeeVoteReminders: [
    'fetchAttendeeVoteReminders',
    'updateAttendeeVoteReminder'
  ],
  attendeeMutual: [
    'deleteAllAttendeeRecords',
    'updateBlockAttendeeSettings',
    'unblockBlockedAttendee',
    'updatePlaceholderValue',
    'updateIsInTopStatus'
  ],
  attendeeReminders: [
    'getAttendeeReminders',
    'editAttendeeReminders',
    'sendAttendeeReminders',
    'resetEmailTemplate'
  ],
  attendeesAllMessages: [
    'fetchMessages'
  ],
  attendeeMessages: [
    'fetchAttendeesMessages'
  ],
  auth: [
    'authenticateUser',
    'deuthenticateUser',
    'submitNewPassword',
    'requestPasswordReset'
  ],
  awardsReminders: [
    'fetchAwardsReminders',
    'postAwardReminders'
  ],
  awardsSettings: [
    'fetchVotingStepOne',
    'fetchVotingStepTwo',
    'fetchVotingStatisticsStepOne',
    'fetchVotingStatisticsStepTwo',
    'putAwardsGeneralSettings',
    'putAwardsStepOneSettings',
    'putAwardsStepTwoSettings'
  ],
  badgeExport: [
    'exportBadgesArchieve'
  ],
  banners: [
    'createBanner',
    'savePageWithBanner',
    'fetchPageWithBanner',
    'fetchBanners',
    'updateBanner',
    'deleteBanner'
  ],
  blitz: [
    'fetchBlitzSubmits',
    'fetchBlitzCounter',
    'hideOrShowEnvelop',
    'addBlitzCompany',
    'updateBlitzSubmitStatus',
    'blitzRemindSubmit'
  ],
  categories: [
    'getCategoriesList',
    'addCategoryList',
    'editCategoryList',
    'deleteCategoryList',
    'getEnabledCategoriesList'
  ],
  cookiesSettings: [
    'updateCookiesAlertSettings'
  ],
  //  'display' module
  companies: [
    'fetchCompaniesList',
    'updateCompanies'
  ],
  emailNotificationSettings: [
    'fetchAdminSettings',
    'updateAdminSettings',
    'fetchAttendeeSettings',
    'updateAttendeeSettings'
  ],
  emailTemplates: [
    'fetchEmailTemplates',
    'postEmailTemplates',
    'updateEmailTemplates',
    'deleteEmailTemplates'
  ],
  emailTemplatesSettings: [
    'updateAttendeeConfirmationTemplate',
    'updateAttendeeMessageTemplate',
    'updateAttendeeToAgendaAdminMessageTemplate',
    'updateAttendeeToSpeakerMessageTemplate',
    'updateAttendeeToParticipantMessageTemplate',
    'updateBlitzSubmittedTemplate',
    'updateContactUsTemplate',
    'updateEnableVideoRequestTemplate',
    'updateInvoiceRefundSendingTemplate',
    'updateInvoiceSendingTemplate',
    'updateIPNSendingTemplate',
    'updateIPNRefundSendingTemplate',
    'updateListingSubmittedTemplate',
    'updateResetPasswordTemplate',
    'updateAdminSetPasswordTemplate'
  ],
  featuredAttendee: [
    'updateFeaturedAttendeePageSettings',
    'sendFeaturedInvitation'
  ],
  formInterpritation: [
    'getInterpritationFormData'
  ],
  galleries: [
    'fetchGalleries',
    'uploadImage',
    'postImageDetails',
    'postAllImagesDetails',
    'updateImageDetails',
    'setImageUrl'
  ],
  generalSettings: [
    'updateGeneralSettings',
    'fetchGeneralSettings',
    'updateVatIdSettings',
    'fetchForbiddenDomains',
    'saveForbiddenDomain',
    'deleteForbiddenDomain',
    'fetchFiles',
    'uploadFileToDatabase',
    'uploadFileToStorage',
    'putGooglePixelNotification',
    'submitStyleSettings',
    'resetStyleSettings',
    'putAttendeePassword'
  ],
  googleAuth: [
    'fetchGoogleAuthLink',
    'fetchGoogleAuthCredentials',
    'googleAuthorize'
  ],
  googleSettings: [
    'updateGoogleAnalyticsSettings',
    'updateGoogleSheetSettings'
  ],
  importExcel: [
    'downloadExcel'
  ],
  invitationSingle: [
    'sendSingleLetter'
  ],
  invoices: [
    'fetchInvoices',
    'resendInvoices',
    'resendIPN',
    'downloadInvoicePDF',
    'downloadInvoicesExcel',
    'downloadIPNpdf'
  ],
  killerFeatureDisplaySettings: [
    'putKillerFeatureDisplaySettings',
    'fetchKillerFeatureDisplaySettings'
  ],
  killerFeatureSettings: [
    'updateGeneralKillerSettings'
  ],
  lastYearAttendee: [
    'fetchLastYearAttendees',
    'uploadLastYearAttendees'
  ],
  lastYearTestimonials: [
    'fetchLastYearTestimonials',
    'setTestimonialsDisplaySettings',
    'createLastYearTestimonials',
    'fetchPablicLYTestimonials',
    'updateLastYearTestimonials',
    'changeLYTestimonialStatus',
    'removeLastYearTestimonial',
    'fetchlastYearTestimonialsByType',
    'fetchTestimonialTypes',
    'addTestimonialTypes',
    'updateTestimonialTypes',
    'removeTestimonialTypes',
    'updateDisplaySettingsTestimonials'
  ],
  listing: [
    'listingPayloadAction',
    'fetchListing',
    'fetchCounterListing',
    'createListing',
    'updateListing',
    'updatePendingListing',
    'updateApproveListing',
    'remindListing',
    'deleteListing',
    'exportListingPDF',
    'createPreviewListingPDF',
    'resetListingStatus'
  ],
  locations: [
    'getLocationsList',
    'addLocationList',
    'removeLocation'
  ],
  mailChimp: [
    'fetchNewsList',
    'editNewsList',
    'fetchSegmentsList'
  ],
  nominationsCategories: [
    'getNominationsCategoriesList',
    'createCategory',
    'updateCategory',
    'deleteCategory'
  ],
  nominees: [
    'getNomineesList',
    'fetchNomineesListWithWiningStatus',
    'addNominee',
    'editNominee',
    'removeNominee',
    'downloadVotingExcel',
    'approveNominee'
  ],
  packages: [
    'getPackagesList',
    'addPackageList',
    'editPackageList',
    'deletePackageList',
    'getPredefinedActivity',
    'addPredefinedActivity',
    'editPredefinedActivity',
    'deletePredefinedActivity',
    'editKillerFeatureData'
  ],
  photoGallery: [
    'fetchPhotoGalleries',
    'createPhotoGallery',
    'editPhotoGallery',
    'removePhotoGallery'
  ],
  promoCodes: [
    'getPromoCodesList',
    'addPromoCode',
    'editPromoCode',
    'updatePromoCodeSettings'
  ],
  registrationVipInvitation: [
    'fetchVipInvitations',
    'updateVipInvitation',
    'deleteVipInvitation',
    'fetchVipInvitationPackage',
    'updateVipInvitationPackage',
    'enableVipInvitationPackage',
    'disableVipInvitationPackage',
    'resendVipInvitation'
  ],
  regularAttendee: [
    'getRegularAttendeeList',
    'setAttendeeApproveStatus',
    'receiveFullAttendeeInfo',
    'editRegularAttendee',
    'fetchRegularAttendeeStatusesCount',
    'sendRequestForPayment'
  ],
  regularAttendeeSettings: [
    'editRegularAttendeeSettings'
  ],
  regularAttendeeType: [
    'getRegularAttendeeType',
    'addRegularAttendeeType',
    'editRegularAttendeeType',
    'deleteRegularAttendeeType'
  ],
  sendGrid: [
    'fetchSendGridTemplates'
  ],
  speakers: [
    'fetchSpeakersList',
    'deleteSpeakerById',
    'draftSpeakerById',
    'publishSpeakerById',
    'createSpeaker',
    'editSpeaker',
    'updateSpeakersPageSettings',
    'patchOrdersSpeaker',
    'setSpeakersVisibleHomepage',
    'fetchSpeakersVisibleHomepage'
  ],
  sponsors: [
    'createSponsorType',
    'fetchSponsorsList',
    'editSponsorType',
    'fetchSponsorTypesList',
    'removeSponsorType',
    'createSponsorTask',
    'createSponsorTier',
    'editSponsorTask',
    'fetchSponsorTiersList',
    'removeSponsorTier',
    'removeSponsorTask',
    'sendReminderWithSponsorTasks',
    'recieveEmailTemplates',
    'editSponsorTier',
    'fetchSponsorTasksList',
    'fetchSponsorsTagsList',
    'editSponsor',
    'deleteSponsor',
    'createNewSponsor',
    'updateSponsorPublish',
    'editSponsorsSettings',
    'updateSponsorDraft',
    'fetchMediaKits',
    'createMediaKit',
    'updateMediaKit',
    'deleteMediaKit',
    'updateSponsorTask',
    'updateMediaKitsSettings'
  ],
  staticContent: [
    'fetchStaticContent',
    'updateStaticContent',
    'createStaticContent',
    'deleteStaticContent'
  ],
  statusDisplayName: [
    'getStatusDisplayNames',
    'updateStatusDisplayNames'
  ],
  tag: [
    'getTag',
    'getTagByType',
    'postTag',
    'putTag',
    'putTagType',
    'deleteTag'
  ],
  testimonials: [
    'fetchTestimonials',
    'updateTestimonial',
    'deleteTestimonial',
    'createTestimonial'
  ],
  upload: [
    'uploadFile'
  ],
  user: [
    'fetchScopesList',
    'fetchUsers',
    'updateUser',
    'deleteUser',
    'createUser',
    'fetchUsersForSuperAdmin',
    'updateUserBySuperAdmin',
    'deleteUserBySuperAdmin',
    'logoutSingleAdmin',
    'logoutAllAdmins',
    'fetchCurrentUserDetails',
    'fetchAdminsActions'
  ],
  videos: [
    'createVideo',
    'fetchVideos',
    'updateVideo',
    'deleteVideo',
    'saveVideosDisplaySettings'
  ],
  voucherPage: [
    'changeVoucherPage'
  ]
}

export default Object.keys(analyticEventCategories).reduce((acc, category) => {
  if (path(['length'], analyticEventCategories[category])) {
    analyticEventCategories[category].forEach(event => {
      acc[event] = category
    })
  }
  return acc
}, {})



// WEBPACK FOOTER //
// ./src/utils/analyticEventCategories.js